module.exports = __webpack_public_path__ + "static/fyndiq-ff4e1974068457be83b4c06fe6a0619f.png";